export const fmtEUR = (value, opts = {}) => {
  const { decimals = 0, compact = false } = opts;
  if (value === null || value === undefined || Number.isNaN(value)) return "€ 0";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    notation: compact ? "compact" : "standard",
  }).format(value);
};

export const fmtNum = (value, decimals = 0) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "0";
  return new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const fmtPct = (value, decimals = 1) => {
  if (value === null || value === undefined || Number.isNaN(value)) return "0%";
  return `${new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)}%`;
};
